module.exports = __webpack_public_path__ + "img/skills-bow-ama-3.daf112a7.png";